import { Trans } from 'react-i18next';

import { priceFormatter } from '@dreryk/react-common';

import { issuedInvoicesTranslationKeys } from '../../../translations';

type IssuedInvoicesTablePriceCellProps = {
   readonly grossPrice: string;
};

export const IssuedInvoicesTablePriceCell = (props: IssuedInvoicesTablePriceCellProps): JSX.Element => {
   if (isNaN(Number(props.grossPrice))) {
      return <>{props.grossPrice}</>;
   }

   return (
      <Trans
         i18nKey={issuedInvoicesTranslationKeys.table.price}
         values={{
            grossPrice: priceFormatter(Number(props.grossPrice)),
         }}
      />
   );
};
